import React, { useState, useEffect } from 'react';

import { useNavigate, useParams, useSubmit } from 'react-router-dom';
import FooterCorp from '../modulos/footerCorp';
import obtieneDatos from '../tools/obtieneDatosCookiesUsuario';

import socket from "../tools/socke";


import comprueboPermisos from '../tools/comprueboPermisos';
import Procesos from './Procesos';
import PostulantesComplemento from './PostulantesComplemento';
import VeoDatos from '../Inscripciones/VeoDatos';




const MenuIngresos = () => {

  const [listadoPresentes, setListadoPresentes] = useState()
  const [veoEstadisticaProceso, setveoEstadisticaProceso] = useState(false)
  socket.emit("estadoInscripcion", "")
  const [estadoInscripcion, setEstadoInscripcion] = useState(false);
  const Usuario = obtieneDatos();
  useEffect(() => {
    const handleInscripcion = (ca) => setEstadoInscripcion(ca);
    socket.on('Inscripcion', handleInscripcion);
    return () => {
      socket.off('Inscripcion', handleInscripcion);
    };
  }, []);
  useEffect(() => {




    if (!Usuario.id) {
      alert("Acceso no Autorizado")
      window.location.href = './';
    }
  }, [listadoPresentes]);



  const navitate = useNavigate()
  const [selectedComponent, setSelectedComponent] = useState('Component6');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const tomoDatos = (datos) => {

  }
  const [permisos, setPermisos] = useState("");

  const guardarPermisos = (permisosString) => {
    setPermisos(permisosString);
//     console.log("Permisos guardados:", permisosString);
  };

  const Component1 = () => <div><><Procesos /></></div>;
  const Component2 = () => <div> {Usuario.destino == 7 || comprueboPermisos(Usuario.funcion, "veo estadistica Proceso") ? <><h4>{estadoInscripcion ? <><h4 style={{ color: "green" }}>Inscripciones Abiertas</h4></> : <><h4 style={{ color: "red" }}>Inscripciones Cerradas</h4></>}</h4>
    {Usuario.destino == 7 ? <button onClick={() => socket.emit("cierraInscripcion", !estadoInscripcion)}>Seteo Inscripcion </button> : ""}
    <h2 onClick={() => { setveoEstadisticaProceso(!veoEstadisticaProceso) }}>{veoEstadisticaProceso ? "Postulantes Segunda Convocatoria -" : "Postulantes Segunda Convocatoria +"}</h2>
    {veoEstadisticaProceso ? <><PostulantesComplemento /></> : ""}




  </> : ""}</div>;


  const handleMenuClick = (component) => {
    setSelectedComponent(component);
    setIsMenuOpen(false); // Cierra el menú al seleccionar cualquier opción
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };


  const handleInputChange = (e) => {
    localStorage.setItem("nombreCon", e.target.value);
  };

  return (
    <div className="menu-container">
      <nav className="menu">
        <div className="hamburger" onClick={toggleMenu}>
          ☰
        </div>
        <div className={`menu-items ${isMenuOpen ? 'open' : ''}`}>


          {comprueboPermisos(Usuario.funcion, "Procesos") ? <div className="menu-item" onClick={() => handleMenuClick('Component1')}>Procesos</div> : ""}


          {comprueboPermisos(Usuario.funcion, "Inscripciones") ? <> <div className="menu-item" onClick={() => handleMenuClick('Component2')}>Inscripciones</div> </> : ""}


          <div className="menu-item" disbled onClick={() => navitate('/usuarioLogueado')}>Volver</div></div>
      </nav>

      <div className="component-display">
        {selectedComponent === 'Component1' && <Component1 />}

        {selectedComponent === 'Component2' && <VeoDatos />}

        {selectedComponent === 'Component5' && (() => navitate('/usuarioLogueado'))}





      </div>
      <div class="footer"><FooterCorp /></div>
    </div>
  );
};

export default MenuIngresos;


